import api from '@/api/index.ts';
import Caching, { getCaching } from '@/plugins/caching.ts';

export default {
    async fetchCalendarViewsWithCaching() {
        const caching = getCaching();
        if (!caching) {
            await this.fetchCalendarViews();
            return;
        }

        try {
            const calendarViews = await caching.getCache(Caching.CALENDAR_VIEWS_CACHE_KEY);
            const sharedCalendarViews = await caching.getCache(
                Caching.SHARED_CALENDAR_VIEWS_CACHE_KEY
            );
            if (calendarViews || sharedCalendarViews) {
                this.calendarViews = calendarViews;

                if (sharedCalendarViews) {
                    this.sharedCalendarViews = sharedCalendarViews;
                }

                setTimeout(async () => {
                    await this.fetchCalendarViews();
                }, 2000);
            } else {
                await this.fetchCalendarViews();
            }
        } catch (e) {
            await this.fetchCalendarViews();
        }
    },

    async fetchCalendarViews() {
        const calendarViewsResponse = (await api.authUser.getCalendarViews()).data;

        this.calendarViews = calendarViewsResponse.calendar_views;
        this.sharedCalendarViews = calendarViewsResponse.shared_calendar_views;

        this.updateCalendarViewCache();
    },

    async addCalendarView(viewData) {
        this.calendarViews.push(viewData);

        this.updateCalendarViewCache();
    },

    async updateCalendarView(viewData) {
        const viewIndex = this.calendarViews.findIndex((v) => v.id == viewData.id);

        if (viewIndex !== -1) {
            this.calendarViews.splice(viewIndex, 1, viewData);
        }

        this.updateCalendarViewCache();
    },

    async deleteCalendarView(viewId) {
        const viewIndex = this.calendarViews.findIndex((v) => v.id == viewId);

        if (viewIndex !== -1) {
            this.calendarViews.splice(viewIndex, 1);
        }

        this.updateCalendarViewCache();
    },

    updateCalendarViewCache() {
        const caching = getCaching();
        if (!caching) {
            return;
        }

        caching.setCache(Caching.CALENDAR_VIEWS_CACHE_KEY, this.calendarViews);
        caching.setCache(Caching.SHARED_CALENDAR_VIEWS_CACHE_KEY, this.sharedCalendarViews);
    },
};
